import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SubmitHandler, useForm, Controller } from 'react-hook-form';
import { Caption, Input, MaskedInput } from 'fronton-react';
import { ApplicationForm } from '../../types';
import { useDispatchRoughWorkAction } from '../../slice';
import { selectLeadId } from '../../selectors';
import { formStyles, sendBtn } from './styles';
import { validation } from './form-config';

export const Form = () => {
	const { control, handleSubmit, reset } = useForm<ApplicationForm>({});
	const leadId = useSelector(selectLeadId);
	const { sendFormRequest } = useDispatchRoughWorkAction();

	const submit: SubmitHandler<ApplicationForm> = data => {
		sendFormRequest(data);
	};
	useEffect(() => {
		if (leadId) {
			reset();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [leadId]);

	return (
		<form onSubmit={handleSubmit(submit)} className={formStyles}>
			<Controller
				name="name"
				control={control}
				rules={validation.name}
				render={({ field, fieldState: { error } }) => (
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					<Input
						fullWidth
						placeholder="Имя"
						error={!!error}
						caption={error && <Caption error message={error.message} />}
						{...field}
					/>
				)}
			/>
			<Controller
				name="phone"
				control={control}
				rules={validation.phone}
				render={({ field, fieldState: { error } }) => (
					<MaskedInput
						mask="+7 (999) 999-99-99"
						{...field}
						placeholder="Телефон"
						error={!!error}
						caption={error && <Caption error message={error.message} />}
					/>
				)}
			/>
			<button type="submit" className={sendBtn}>
				Отправить
			</button>
		</form>
	);
};
